import { TransactionHistoryTable, FilesReportsNavigation } from '@pages/files-reports/containers';
import { DateRangeType, DateRange } from '@ui/components';
import { HasPermission } from '@shared/components';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { dateTimeRanges } from '@ui/utils';
import { useState, useMemo } from 'react';
import { DateTime } from 'luxon';

const DEFAULT_DATE_RANGE = {
  from: DateTime.now().startOf('month').toJSDate(),
  to: DateTime.now().toJSDate(),
};

export const TransactionHistory = () => {
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const initialDate = useMemo(() => {
    const from = searchParams.get('dateFrom')
      ? new Date(searchParams.get('dateFrom')!)
      : DEFAULT_DATE_RANGE.from;
    const to = searchParams.get('dateTo')
      ? new Date(searchParams.get('dateTo')!)
      : DEFAULT_DATE_RANGE.to;
    return { from, to };
  }, [searchParams]);

  const [date, setDate] = useState<DateRangeType | undefined>(initialDate);

  const autoRangeOptions = useMemo(() => {
    return dateTimeRanges.map(({ label, value }) => ({
      label: t(`FILES_REPORTS.TRANSACTION_HISTORY.DATE_RANGE.${label}`),
      value,
    }));
  }, [t]);

  return (
    <HasPermission
      permissionFeature="REPORTS_FILES_TRANSACTION_HISTORY"
      permissionType="READ"
      redirect
    >
      <div className="flex justify-between mb-4">
        <FilesReportsNavigation />

        <DateRange
          translations={{
            yesterday: t('TIME.YESTERDAY'),
            today: t('TIME.TODAY'),
          }}
          placeholder={t('FILES_REPORTS.TRANSACTION_HISTORY.DATE_RANGE.PLACEHOLDER')}
          autoRangeOptions={autoRangeOptions}
          className="ml-auto"
          onSelect={setDate}
          selected={date}
          lang={language}
        />
      </div>
      <TransactionHistoryTable
        dateFrom={date?.from ?? DEFAULT_DATE_RANGE.from}
        dateTo={date?.to ?? DEFAULT_DATE_RANGE.to}
      />
    </HasPermission>
  );
};
